/**
 * Method to execute callback basis keyboard events
 * @param  {object} payload
 *      payload = {
 *         {eventType}: [
 *                {function},   Callback to execute
 *                {boolean},    Whether to call stopPropagation
 *                {boolean}     Whether to call preventDefault
 *             ]
 *      }
 *      Supported Event Types:
 *         1. onEnter: Called when enter or space key is pressed
 *
 * Usage: <Button tabIndex={0} onKeyDown={interpretKey({ onEnter: [onHelp, false, true] })}/>
 */
export function interpretKey(payload) {
    return (event) => {
        Object.keys(payload).forEach((key) => {
            const { key: eventKey } = event;
            const [callBack, stopPropagation, preventDefault] = payload[key] || [];
            let executeCallback = false;
            switch (key) {
            case 'onEnter':
                executeCallback = eventKey === 'Enter' || eventKey === ' ';
                break;
            case 'onTab':
                executeCallback = eventKey === 'Tab';
                break;
            case 'onEscape':
                executeCallback = eventKey === 'Escape';
                break;
            default:
            }
            if (executeCallback) {
                if (callBack && typeof callBack === 'function') {
                    callBack(event);
                }
                if (stopPropagation) {
                    event.stopPropagation();
                }
                if (preventDefault) {
                    event.preventDefault();
                }
            }
        });
    };
}
